import * as THREE from "three";

type Color = { Name: string; R: number; G: number; B: number };

function createMesh(vertices: Array<number>, indices: Array<number>, normals?: Array<number>, color?: Color): THREE.Mesh {
	const geometry = new THREE.BufferGeometry();

	geometry.setAttribute("position", new THREE.Float32BufferAttribute(vertices, 3));
	if (normals?.length) {
		geometry.setAttribute("normal", new THREE.Float32BufferAttribute(normals, 3));
	} else {
		geometry.computeVertexNormals();
	}

	geometry.setIndex(indices);
	geometry.computeBoundingBox();
	geometry.computeBoundingSphere();

	const threeJsColor = parseDotNetColor(color);
	// const materialService = ServiceRegistry.getMaterialService();

	// const material = threeJsColor
	// 	? materialService.getMaterialByColor(threeJsColor)
	// 	: materialService.getDefaultMaterial();

	const material = new THREE.MeshBasicMaterial({
		color: threeJsColor,
		side: THREE.DoubleSide,
		transparent: true,
		opacity: 0.8,
		depthTest: true,
	});

	var object = new THREE.Mesh(geometry, material);
	object.castShadow = true;
	object.receiveShadow = true;
	object.material.needsUpdate = true;
	return object;
}

function parseDotNetColor(colorObj?: Color): string {
	if (colorObj?.Name && colorObj.Name.length === 8) {
		// "ff648085" = "AARRGGBB", so strip alpha and keep RGB
		return `#${colorObj.Name.substring(2)}`; // => "#648085"
	}

	// Fallback: build from RGB
	const r = colorObj?.R ?? 200;
	const g = colorObj?.G ?? 200;
	const b = colorObj?.B ?? 200;

	return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export { createMesh };
